(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bespoke"] && !window.DesignMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery .image-wrapper a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('#mw-modal-image');
  const closeModal = modal.querySelector('#mw-modal-close'); // Close button
  let modalTitle = document.createElement("div");
  modalTitle.className = "modal-titles";
  const modalContent = modal.querySelector('.mw-modal-content');
  modalContent.appendChild(modalTitle);

  // Arrows for navigation
  const prevArrow = modal.querySelector('#mw-modal-prev');
  const nextArrow = modal.querySelector('#mw-modal-next');

  let currentIndex = 0;

  // Function to show modal popup
  function showModal(index) {
    const image = images[index];
    modalImage.src = window.innerWidth > 749 ? image.dataset.desktop : image.dataset.mobile;
    modalTitle.innerHTML = `<p class="modal-caption">${image.dataset.title}</p><p class="modal-number">${image.dataset.titleNumber}</p>`;
    modal.classList.add('show');
    currentIndex = index;
  }

  // Function to hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }

  // Function to show the next image
  function showNext() {
    currentIndex = (currentIndex + 1) % images.length; // Loop back to the start
    showModal(currentIndex);
  }

  // Function to show the previous image
  function showPrev() {
    currentIndex = (currentIndex - 1 + images.length) % images.length; // Loop back to the end
    showModal(currentIndex);
  }

  // Prevent closing modal when clicking inside the modal content
  modalContent.addEventListener('click', function(e) {
    e.stopPropagation();
  });

  // Add event listener for closing modal
  closeModal.addEventListener('click', function(e) {
    e.preventDefault(); // Prevent default action
    hideModal();
  });

  // Bind show modal function to image clicks
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault();
      showModal(index);
    });
  });

  // Add event listeners for arrows
  nextArrow.addEventListener('click', function(e) {
    e.preventDefault();
    showNext();
  });

  prevArrow.addEventListener('click', function(e) {
    e.preventDefault();
    showPrev();
  });

  // Close modal when clicking on the modal background
  modal.addEventListener('click', hideModal);
})();



document.addEventListener("DOMContentLoaded", function() {
    const items = document.querySelectorAll('.mw-image-gallery__item');
    const itemsPerPage = 50;
    let currentPage = 1;

    // Hide 'Load More' button if items are 9 or less
    function checkInitialItemCount() {
        if (items.length <= itemsPerPage) {
            document.getElementById('load-more').style.display = 'none';
        }
    }

    // Initially hide all items after the first 9
    function initialHideItems() {
        items.forEach((item, index) => {
            if (index >= itemsPerPage) {
                item.style.display = 'none';
            }
        });
    }

    // Function to show the next set of items
    function showNextSetOfItems() {
        const maxIndex = itemsPerPage * (currentPage + 1);
        items.forEach((item, index) => {
            if (index < maxIndex) {
                item.style.display = ''; // Or you could use 'block', depending on your layout
            }
        });
        currentPage++;

        // If all items are visible, hide the Load More button
        if (maxIndex >= items.length) {
            document.getElementById('load-more').style.display = 'none';
        }
    }

    checkInitialItemCount();
    initialHideItems();
    document.getElementById('load-more').addEventListener('click', showNextSetOfItems);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-testimonials"] && !window.DesignMode) return;
  try {
    
  // Initialize the slider with conditional navigation arrows
  jQuery(document).ready(function($) {
    var $carousel = $('.fadeslides');
    // Count the number of testimonials
    var testimonialCount = $carousel.find('.testimonial-content').length;

    $carousel.flickity({
      // options
      cellAlign: 'center',
      adaptiveHeight: true,
      pageDots: true,
      contain: true,
      autoPlay: 4000,
      // prevNextButtons: testimonialCount > 1, // Show arrows only if more than one testimonial
      prevNextButtons: false,
      fade: true,
      wrapAround: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists-list"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Select all links with hashes
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        // Extract the target element's ID from the anchor's href attribute
        var targetId = this.getAttribute('href');
        var targetElement = document.querySelector(targetId);

        if (targetElement) {
          // Get the top position of the target element
          const targetPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = targetPosition + window.pageYOffset - 50;

          // Scroll to the target element smoothly, stopping 50px above it
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
